@if ((absenceGroups$ | async); as absenceGroups) {
  <div class="absences-container">
    @if (absenceGroups.length > 0) {
      <h4 class="absences-title">{{ 'absences.absences' | translate }}</h4>
    }
    @for (group of absenceGroups; track group.department?.['@id']) {
      <div
        class="department-block"
        [style.background]="tintOf(group)"
        [style.border-left-color]="edgeColorOf(group)"
      >
        <div class="department-name">
          {{ group.department ? group.department.name : ('departments.withoutDepartment' | translate) }}
        </div>
        <div class="staff-figures">
          @if (driverCountOf(group); as drivers) {
            <ng-container
              *ngTemplateOutlet="staffBar; context: { label: 'departments.people' | translate, count: drivers }"
            ></ng-container>
          }
          @if (vehicleCountOf(group); as vehicles) {
            <ng-container
              *ngTemplateOutlet="staffBar; context: { label: 'departments.vehicles' | translate, count: vehicles }"
            ></ng-container>
          }
        </div>
        @for (absence of group.absences; track absence['@id']) {
          <div class="absence-item">
            <div class="absence-target">{{ labelOf(absence) }}</div>
            <div class="absence-dates">
              {{ absence.startDate | date: 'd MMM' }}
              @if (absence.startDate != absence.endDate) {
                - {{ absence.endDate | date: 'd MMM' }}
              }
              @if ((absence.class | absenceClass | async); as absenceClass) {
                <mat-icon
                  class="material-icons absence-class-icon"
                  [style.color]="colorOf(absenceClass)"
                  [matTooltip]="absenceClass.name"
                >{{ iconOf(absenceClass) }}</mat-icon>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
}

<ng-template #staffBar let-label="label" let-count="count">
  <div class="staff-bar">
    <div class="staff-bar-segment present" [style.width.%]="presentShare(count)"></div>
    <div class="staff-bar-segment absent" [style.width.%]="absentShare(count)"></div>
  </div>
  <div class="staff-legend">
    <span class="staff-legend-label">{{ label }}</span>
    <span class="staff-legend-present" [matTooltip]="'absences.present' | translate">{{ count.present }}</span>
    <span class="staff-legend-absent" [matTooltip]="'absences.absent' | translate">{{ count.absent }}</span>
  </div>
</ng-template>
